import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);
const AUTH_STORAGE_KEY = 'discord_auth_user'; // Key for localStorage

// Helper function to get initial state from localStorage
const getInitialAuthState = () => {
    try {
        const storedUser = localStorage.getItem(AUTH_STORAGE_KEY);
        if (storedUser) {
            const userData = JSON.parse(storedUser); // Parse the JSON string
            // Basic valiwwdation (optional but good practice)
            if (userData && userData.userID && userData.userName) {
                 return {
                    loggedIn: true,
                    userID: userData.userID,
                    userName: userData.userName,
                    userAvatar: userData.userAvatar, 
                    guildList: userData.guildList || []
                 };
            }
        }
    } catch (error) {
        console.error("Failed to parse auth state from localStorage:", error);
        // If parsing fails, clear the potentially corrupted item
        localStorage.removeItem(AUTH_STORAGE_KEY);
    }
    // Default state if nothing valid is found in localStorage
    return {
        loggedIn: false,
        userID: null,
        userName: null,
        userAvatar: null,
        guildList: []
    };
};


export const AuthProvider = ({ children }) => {
    // Initialize state using the helper function
    const initialState = getInitialAuthState();
    const [loggedIn, setLoggedIn] = useState(initialState.loggedIn); // Typo: should be loggedIn
    const [userID, setUserID] = useState(initialState.userID);
    const [userName, setUserName] = useState(initialState.userName);
    const [userAvatar, setUserAvatar] = useState(initialState.userAvatar);
    const [guildList, setGuildList] = useState(initialState.guildList)
    // Login function: Sets state AND saves to localStorage
    
    const login = (user) => {
        console.log("User login function called with user:", user);
        const userData = {
             userID: user.userId,
             userName: user.username,
             userAvatar: user.avatar,
             guildList: user.guildList
        };
        
        try {
            // Save the necessary user data as a JSON string
            localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(userData));

            // Update React state (this will cause re-renders)
            setLoggedIn(true); // Corrected state variable name
            setUserID(userData.userID);
            setUserName(userData.userName);
            setUserAvatar(userData.userAvatar);
            setGuildList(userData.guildList )
            console.log("User data saved to localStorage and state updated.");

        } catch (error) {
             console.error("Failed to save auth state to localStorage:", error);
             // Handle potential storage errors (e.g., storage full)
        }
    };

    // Logout function: Resets state AND clears localStorage
    const logout = () => {
        try {
            // Remove the item from localStorage
            localStorage.removeItem(AUTH_STORAGE_KEY);

             // Reset React state
            setLoggedIn(false); // Corrected state variable name
            setUserID(null);
            setUserName(null);
            setUserAvatar(null);
            setGuildList([]);
            console.log("User data cleared from localStorage and state reset.");

        } catch (error) {
            console.error("Failed to remove auth state from localStorage:", error);
        }
    };


    useEffect(() => {
         if (userID) {
             //console.log("AuthProvider state updated:", { userID, userName, userAvatar, loggedIn });
       }
     }, [userID, userName, userAvatar, loggedIn]);


    const contextValue = {
        // Use the correct state variable name here too
        loggedIn: loggedIn, // Providing the state variable named 'loggedIn'
        userID,
        userName,
        userAvatar,
        guildList,
        login,
        logout
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};